if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

/* window.onload = function() {
	var sectionId = location.hash.substring(1);
   var section = document.getElementById(sectionId);
   let heightScroll = 100

   	if (section) { 

		window.innerWidth > 640 
			? heightScroll = 150
			: heightScroll = 200

		window.scrollBy(0, section.offsetTop - heightScroll); 
	}
} */

(function () {
	// ADD LOGO TO MAIN NAV MOBILE
	const mobileNav = document.querySelector('.navigation');
	if (mobileNav) {
		mobileNav.insertAdjacentHTML('afterbegin', '<a class="navigation_logo" href="/"><img src="/assets/svg/logo.svg" alt="Cherry Valley Hotel Nav Logo" /></a>');
	}

	// CLOSE MAIN NAV MOBILE
	document.querySelectorAll('.close-menu').forEach((btn) => {
		if (mobileNav) {
			btn.addEventListener('click', (e) => {
				mobileNav.classList.remove('active');
				document.body.classList.remove('noscroll');
			});
		}
	});

	// OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-show_nav_m]').forEach((btn) => {
		if (mobileNav) {
			btn.addEventListener('click', (e) => {
				mobileNav.classList.add('active');
				document.body.classList.add('noscroll');
			});
		}
	});
	

	// WRAP TABLES
	document.querySelectorAll('.text table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableWrap');
		tableWrapper.setAttribute('data-fromjs', '1');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	// ACCORDIONs
	document.querySelectorAll('[data-accordion]').forEach((acc) => {
		acc.querySelectorAll('[data-accordion_item]').forEach((item, i) => {
			const accHead = item.querySelector('[data-accordion_head]');
			const accBody = item.querySelector('[data-accordion_body]');
			accHead.addEventListener('click', (e) => {
				acc.querySelectorAll('[data-accordion_item]').forEach((citem) => {
					const cbody = citem.querySelector('[data-accordion_body]');
					if (accBody !== cbody) {
						cbody.slideUp(300, () => citem.classList.remove('active'));
					}
				});
				accBody.slideToggle(300, () => item.classList.toggle('active'));
			});

			// if (i === 0) accHead.click();
		});
	});

	// TOGGLE MAIN NAV
	const mainNav = document.querySelector('.mainNav');
	if (mainNav) {
		document.querySelectorAll('.js-toggleMainNav').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				mainNav.classList.toggle('active');
				document.body.classList.toggle('noscroll', mainNav.classList.contains('active'));
				btn.classList.toggle('active', mainNav.classList.contains('active'));
			});
		});
	}

	// ANIMATE FORM LABELS ON FOCUS
	const formSelectors = '.form-module, .email-signup';
	const fieldSelectors = '.form-module__field input, .form-module__field select, .form-module__field textarea, .field.input input';
	document.querySelectorAll(formSelectors).forEach((form) => {
		form.querySelectorAll(fieldSelectors).forEach((field) => {
			field.addEventListener('focus', () => field.parentElement.classList.add('move'));
		});
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	// SWIPER
	const swiperClass = '.sym-slides';
	const swiperOps = {
		speed: 1000,
		loop: true,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
		pagination: {
			el: ".swiper-pagination",
		}
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		let combinedOps = Object.assign({}, swiperOps, dataOps);

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		const wrapper = item.closest('[data-swiper-wrapgoto]') || item.parentNode;

		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			wrapper.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	document.querySelectorAll('[data-swiper-prev]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slidePrev());
	});
	document.querySelectorAll('[data-swiper-next]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slideNext());
	});

	let slider_swiper_images = new Swiper(".swiper_slider-images", {
        rewind:true,
        speed: 900,
        effect: 'fade',
		slidesPerView: 2,
		initialSlide: 1,
		allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        }
    });
	let slider_swiper_content = new Swiper(".swiper_slider-content", {
        rewind:true,
        speed: 900,
        effect: 'fade',
		slidesPerView: 1,
        fadeEffect: {
            crossFade: true
        },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		controlled: true,
		controller:{
			control: slider_swiper_images,
		},
    });


	let slider_new_swiper = new Swiper(".slider_new__swiper", {
        rewind:true,
        speed: 900,
        effect: 'fade',
		slidesPerView: 1,
        fadeEffect: {
            crossFade: true
        },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		autoHeight: true,
		breakpoints: {
			767: {
				autoHeight: false,
			}
		}
    });


	// LBX CUSTOM GALLERY
	const lbx_gallery = new LBX('.js-lbx_gallery');
	lbx_gallery.icons.prev =
		'<svg width="40" height="40" viewBox="0 0 40 40" fill="#2a3240" stroke="#ce5f73" stroke-width="1.8" xmlns="http://www.w3.org/2000/svg"><path d="M 1 1 H 39 V 39 H 1 Z" /><path d="M 25 10 L 15 20 L 25 30" /></svg>';
	lbx_gallery.icons.next =
		'<svg width="40" height="40" viewBox="0 0 40 40" fill="#2a3240" stroke="#ce5f73" stroke-width="1.8" xmlns="http://www.w3.org/2000/svg"><path d="M 1 1 H 39 V 39 H 1 Z" /><path d="M 15 10 L 25 20 L 15 30" /></svg>';
	lbx_gallery.icons.close =
		'<svg width="40" height="40" viewBox="0 0 40 40" fill="#2a3240" stroke="#ce5f73" stroke-width="1.8" xmlns="http://www.w3.org/2000/svg"><path d="M 1 1 H 39 V 39 H 1 Z" /><path d="M 10 10 L 30 30 M 30 10 L 10 30" /></svg>';
	lbx_gallery.fullScreen = true;

	// GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
		customLightbox.wideArrows = true;
	}
})();
